/* eslint-disable no-undef */
import { styled } from '@mui/material';

export const Styles = {
  CarouselContainer: styled('div')(({ theme }) => ({
    position: 'relative',
    width: '788px',
    height: 'max-content',
    overflow: 'hidden',
    borderRadius: '5px',
    margin: '20px auto',
    boxShadow: '0 3px 6px rgba(209, 209, 209, 0.88)',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '300px',
      margin: '20px 0'
    }
  })),

  Slide: styled('div')<{ backgroundImage: string }>(
    ({ backgroundImage, theme }) => ({
      flexGrow: 1,
      //minWidth: '788px',
      minHeight: '455px',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundImage: `url(${backgroundImage})`,
      transition: 'transform 0.5s ease',
      [theme.breakpoints.down('md')]: {
        minWidth: '100%',
        height: '300px'
      }
    })
  ),

  Arrow: styled('button')<{ direction: 'left' | 'right' }>(({ direction }) => ({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    width: '47px',
    height: '114px',
    color: 'white',
    border: 'none',
    padding: '10px',
    cursor: 'pointer',
    zIndex: 10,
    ...(direction === 'left' ? { left: '10px' } : { right: '10px' })
  })),

  OverlayButton: styled('button')({
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    height: '55px',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    fontSize: '18px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 20
  })
};
